<template>
  <el-card>
    <section>
      <el-col :span="24">
        <div>
          <el-form size="small" :inline="true">
            <el-form-item label="类型">
              <el-select clearable v-model="filters.status" placeholder="请选择类型">
                <el-option
                    v-for="item in statusList"
                    :key="item.dictKey"
                    :label="item.name"
                    :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
            <div style="float: right">
              <el-form-item>
                <el-button-group>
                  <el-button type="primary" icon="el-icon-search" @click="getData()">查询</el-button>
                  <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
                </el-button-group>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="data">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="date" label="日期" min-width="120">
        </el-table-column>
        <el-table-column prop="status" label="类型" min-width="120" :formatter="fmt_status">
        </el-table-column>
        <el-table-column label="操作" min-width="70">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <el-dialog title="编辑" :visible.sync="formVisible" :close-on-click-modal="false" :before-close="cancelForm">
        <el-form :model="form" label-width="100px" ref="form">
          <div style="padding-top: 10px">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="类型" prop="status">
                  <el-select clearable v-model="form.status" placeholder="请选择类型">
                    <el-option
                        v-for="item in statusList"
                        :key="item.dictKey"
                        :label="item.name"
                        :value="item.dictKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click.native="cancelForm">取消</el-button>
          <el-button  size="medium" type="primary" @click.native="formSubmit()">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>
<script>

/* eslint-disable */
import { doPost } from '../../api/api'

export default {
  data () {
    return {
      statusList: [{ name: '休息日', dictKey: '1' }, { name: '工作日', dictKey: '2' }],
      filters: {status:''},
      data: [],
      total: 0,
      user: {},
      form: {},
      title: '',
      formVisible: false,
    }
  },

  methods: {
    fmt_status (row) {
      if (row.status === '1') {
        return '休息日'
      }
      if (row.status === '2') {
        return '工作日'
      }
      return ''
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getData()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getData()
    },
    // 获取用户列表
    getData () {
      this.loading = true
      doPost('/legalHolidays/getPageList', this.filters).then((res) => {
        this.total = res.result.total
        this.data = res.result.list
        console.log(this.data)

        this.loading = false
      })
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 点击取消(处理规则校验)
    cancelForm () {
      this.getData()
      this.formVisible = false
      this.$refs['form'].resetFields()
    },
    handleEdit (row, type) {
      this.form = {
        id: row.id
      }
      doPost('/legalHolidays/getById', this.form).then((res) => {
        this.form = res.result
        this.formVisible = true
      })
    },
    // 提交
    formSubmit: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.formLoading = true
            doPost('/legalHolidays/saveOrUpdate', this.form).then((res) => {
              this.formLoading = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.formVisible = false
              this.getData()
            })
          }).catch(() => {
          })
        }
      })
    },

  },
  mounted () {
    var user = JSON.parse(sessionStorage.getItem('user'))
    this.user = user
    this.getUsers()
  }
}

</script>

<style scoped>
#container {
  width: 100%;
  height: 500px;
}
</style>
